import * as Common from '@/tenant/common';

export class StockKey extends Common.ObjectBase{
  constructor(){
    super('StockKey')
    this.binders.segment = new Common.ModelBinder(Common.Segment);
    this.binders.warehouse = new Common.ModelBinder(Common.Counterpart);
    this.binders.commodity = new Common.ModelBinder(Common.Commodity);
    this.binders.sku = new Common.ModelBinder(Common.SKU);
  }

  public id: number = 0;
  public segmentId: number = 0;
  public segment: Common.Segment = null;
  public warehouseId: number = 0;
  public warehouse: Common.Counterpart = null;
  public commodityId: number = 0;
  public commodity: Common.Commodity = null;
  public skuId: number = 0;
  public sku: Common.SKU = null;
  public deliveryId: number = 0;
  public projectItem : Common.ProjectItem = null;
  public projectItemNo : string = null;
  // 予備項目
  public reserveText1: string  = '';
  public reserveText2: string  = '';
  public reserveText3: string  = '';
  public reserveText4: string  = '';
  public reserveText5: string  = '';
  public reserveText6: string  = '';
  public reserveMemo1: string  = '';
  public reserveMemo2: string  = '';
  public reserveMemo3: string  = '';
  public reserveDate1: Date  = null;
  public reserveDate2: Date  = null;
  public reserveDate3: Date  = null;
  public reserveList1: number  = null;
  public reserveList2: number  = null;
  public reserveList3: number  = null;
}